<template>
<d-skeleton v-if="isLoading">slot_string</d-skeleton>
<d-markup v-else-if="ashtml" :text="markup_text" :values="markup_values"></d-markup>
 <span v-else>{{ text }}</span>
</template>

<script setup>
import { computed, useSlots, defineProps } from 'vue'
const slots = useSlots();
// globals
import { useTranslationsStore } from '@/dod/store/dtranslations';
const translationsStore = useTranslationsStore(); // Use the globally registered store

const defaultSlotContent = computed(() => slots.default ? slots.default() : null);
// props
const props = defineProps({  
    ashtml: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    item: {type: Object}
})

// computed
const slot_string = computed(() => defaultSlotContent?.value?.[0]?.children ?? "")
const translated = computed(() => isLoading.value ? "": translationsStore.translate(slot_string.value, replaceValues.value))
const isLoading = computed(() => !translationsStore.loaded || props.loading)
const translate = computed(() => props.item?.translate === false ? false: true)
const text = computed(() => translate.value? translated.value : slot_string.value)
const replaceValues = computed(() => props.item?.replaceValues ?? {})
// ashtml: only the translation's own <span class='bold'>/<br/> is markup, never v-html; the replace values
// (player names) are filled in after parsing and always stay text
const markup_text = computed(() => isLoading.value ? "" : translate.value ? translationsStore.translate(slot_string.value) : slot_string.value)
const markup_values = computed(() => translate.value ? replaceValues.value : null)
</script>
